import React from 'react';

import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";

import ContentBox from "../../../../../../ui/ContentBox";
import SkeletonLoader from "../../../../../../ui/SkeletonLoader";

const TechnologyInformation = ({selectedTechnology, isLoading}) => {
    return (
        <div className="mt-3">
            {
                isLoading ?
                <SkeletonLoader type={"line"} count={2} currentPage={"technologies"} />
                :
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <Row>
                        <Col lg={6} className="mb-3">
                            <ContentBox label={"Name"} value={selectedTechnology?.name} />
                        </Col>
                        <Col lg={6} className="mb-3">
                            <ContentBox label={"Description"} value={selectedTechnology?.description} />
                        </Col>
                        <Col lg={6} className="mb-3">
                            <ContentBox label={"Website"} value={selectedTechnology?.website} />
                        </Col>
                        <Col lg={6} className="mb-3">
                            {selectedTechnology !== "" && <ContentBox label={"Categories"} value={selectedTechnology?.categories.join(", ")} />}
                        </Col>
                    </Row>
                </motion.div>
            }            
        </div>
    )
}

export default TechnologyInformation;